import { staticAssetUrl } from '../utils/mediaUrl'

export function mockImg(file) {
  return staticAssetUrl(`assets/index1/mock/${file}`)
}
